module.exports = __webpack_public_path__ + "img/153-1c92a3.png";